module.exports = __webpack_public_path__ + "img/peter-krusager.7b5d43cd.png";